<app-price-discovery-card *ngFor="let price of priceDiscovery | orderBy: 'CommodityName'"
                          [priceDiscovery]="price" [hidden]="isViewable(price.CommodityCode)">
</app-price-discovery-card>

